import React, { useMemo } from "react";
import * as THREE from "three";
import { Line } from "@react-three/drei";
import { getContours } from "./ContourHelper";
import * as d3 from "d3";

const Contours3D = ({ areaResults, values, colors, visible, grid, autoContourValues }) => {
    const dataMax = useMemo(() => {
        const rawData =
            areaResults[0]?.calcResults?.outdoorResults?.[0]?.contourResults;

        if (!rawData) return 0;
        return Math.max(...rawData.map(parseFloat));
    }, [areaResults]);

    const dataMin = 1;

    const thresholds = useMemo(() => {
        if (!autoContourValues) {
            return values;
        } else {
            const numContours = 7;
            const maxOffset = (dataMax - dataMin) * 0.15;
            const adjustedMax = dataMax - maxOffset;
            const step = (adjustedMax - dataMin) / (numContours - 1);
            return Array.from({ length: numContours }, (_, i) => dataMin + i * step);
        }
    }, [autoContourValues, values, dataMin, dataMax]);

    const colorScale = useMemo(
        () => d3.scaleSequential(d3.interpolateSpectral).domain([dataMax, dataMin]),
        [dataMin, dataMax]
    );

    const contourLines = useMemo(() => {
        const rawData =
            areaResults[0]?.calcResults?.outdoorResults?.[0]?.contourResults;

        if (!rawData || !grid[0]?.origin?.x?.length || !grid[0]?.origin?.y?.length) {
            return [];
        }

        const width = Math.round(grid[0].origin.x.length / grid[0].xSpacing);
        const height = Math.round(grid[0].origin.y.length / grid[0].ySpacing);

        const data = rawData.map(parseFloat);
        const grid2D = [];

        for (let y = 0; y < height; y++) {
            const row = [];
            for (let x = 0; x < width; x++) {
                row.push(data[y * width + x] ?? 0);
            }
            grid2D.push(row);
        }

        // console.log("grid2D", grid2D);
        // console.log("width", width, "height", height);

        const cols = Math.round(grid[0].origin.x.length / grid[0].xSpacing);
        const rows = Math.round(grid[0].origin.y.length / grid[0].ySpacing);
        
        const xScale = d3.scaleLinear()
          .domain([0, cols - 1])
          .range([grid[0].origin.x.start, grid[0].origin.x.start + (cols) * grid[0].xSpacing]);
        
        const yScale = d3.scaleLinear()
          .domain([0, rows - 1])
          .range([grid[0].origin.y.start, grid[0].origin.y.start + (rows) * grid[0].ySpacing]);
        




        const z = 0.1;

        const lines = [];

        thresholds.forEach((level, i) => {
            const color = autoContourValues ? colorScale(level) : colors[i] || "#0000ff";
            const contours = getContours(grid2D, level);

            contours.forEach((path) => {
                const points = path.map(([x, y]) => {
                    const posX = xScale(x);
                    const posY = yScale(y);

                    return new THREE.Vector3(posX, -posY, z);
                });

                if (points.length > 1) {
                    lines.push({ points, color });
                }
            });
        });

        return lines;
    }, [areaResults, thresholds, colors, grid, colorScale]);

    if (!visible) return null;

    return (
        <>
            {contourLines.map((line, i) => (
                <Line key={i} points={line.points} color={line.color} lineWidth={2} />
            ))}

            <mesh position={[grid[0].origin.x.start, -grid[0].origin.y.start, 0.5]}>
                <sphereGeometry args={[0.2, 16, 16]} />
                <meshStandardMaterial color="hotpink" />
            </mesh>


        </>
    );
};

export default Contours3D;
